import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";

export interface WhoamiResponse {
  email: string;
  name: string;
  roles: string[];
  company_ids: string[];
  claims: Record<string, unknown>;
}

export interface SnowflakeRow {
  USER?: string;
  ROLE?: string;
  COMPANY_IDS?: string | null;
  [key: string]: unknown;
}

export function useWhoami() {
  return useQuery({
    queryKey: ["whoami"],
    queryFn: () => apiFetch<WhoamiResponse>("/whoami/"),
  });
}

export function useSnowflakePing() {
  return useQuery({
    queryKey: ["whoami", "snowflake-ping"],
    queryFn: () => apiFetch<SnowflakeRow[]>("/whoami/snowflake-ping"),
    retry: false,
  });
}
